// extracted by mini-css-extract-plugin
export default {"paperworkMissingButton":"payableInvoicesList_paperworkMissingButton__UjkJ3","seeAttachmentsButton":"payableInvoicesList_seeAttachmentsButton__iwFcZ"};